import { createReducer, on } from '@ngrx/store';
import * as removeBankActions from '../actions/remove-bank.actions';
import { IRemoveBankResponse } from '../models/employee-bank-detail.model';

export const removeBankFeatureKey = 'removeBank';

export interface RemoveBankState {
  loading: boolean;
  response: IRemoveBankResponse | null;
  error: any;
}

export const initialState: RemoveBankState = {
  loading: false,
  response: null,
  error: null
};

export const reducer = createReducer(
  initialState,
  on(removeBankActions.removeBank, state => ({ ...state, loading: true, error: null })),
  on(removeBankActions.removeBankSuccess, (state, { response }) => ({ ...state, loading: false, response })),
  on(removeBankActions.removeBankFailure, (state, { error }) => ({ ...state, loading: false, error }))
);